import { ADD_VENDOR } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case ADD_VENDOR.LOAD:
      return {
        ...state,
        loading: true,
      };
    case ADD_VENDOR.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case ADD_VENDOR.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
